import type { FeaturedToy } from '../types/toy'

export const FEATURED_TOYS_URL = '/data/toy-index.json'

export async function fetchFeaturedToys(
  options?: { signal?: AbortSignal; cache?: RequestCache },
): Promise<FeaturedToy[]> {
  const res = await fetch(FEATURED_TOYS_URL, {
    signal: options?.signal,
    cache: options?.cache,
  })
  if (!res.ok) throw new Error(`Request failed: ${res.status}`)
  const data = (await res.json()) as unknown
  if (!Array.isArray(data)) throw new Error('toy-index.json is not an array')
  return data as FeaturedToy[]
}
